import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().min(1, 'Campo e-mail é obrigatório').email('Use um formato de e-mail válido'),
  password: z.string().min(6, 'Campo senha tem o mínimo de 6 caracteres'),
})

export type LoginValidationSchema = z.infer<typeof loginSchema>

export const renewSessionSchema = loginSchema.pick({
  password: true,
});

export type RenewSessionValidationSchema = z.infer<typeof renewSessionSchema>;
